<template>
	<div class=" padding-left-30 padding-right-30 padding-bottom-30">
		<div class="vctb-list">
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==0}" @click="vctbIndex=0">
				经营异常 ({{jygroup.totalnum}})
			</div>
			<div class="vctb-item" :class="{'vctb-item-active':vctbIndex==1}" @click="vctbIndex=1">
				行政处罚 ({{xzgroup.totalnum}})
			</div>
		</div>
		<div class="padding-left-10 padding-right-10 ">

			<template v-if="vctbIndex==0">
				<div class="box5 box2_cc">
					<div class="box5_text2 text-bold">列入日期</div>
					<div class="box5_text2 text-bold">列入经营异常名录原因 </div>
					<div class="box5_text2 text-bold">列入决定机关</div>
					<div class="box5_text2 text-bold">移出日期</div>
					<div class="box5_text2 text-bold">移出经营异常名单原因</div>
					<div class="box5_text2 text-bold">移出决定机关</div>
				</div>
				<div v-for="(item, index) in jy_list" :key="index" class="box5">
					<div class="box5_text2">{{ item.addDate||"--" }} </div>
					<div class="box5_text2">{{ item.addReason ||"--" }} </div>
					<div class="box5_text2">{{ item.addOrgan||"--"  }} </div>
					<div class="box5_text2">{{ item.removeDate||"--"  }}</div>
					<div class="box5_text2">{{ item.removeReason||"--"  }}</div>
					<div class="box5_text2">{{ item.removeOrgan||"--"  }}</div>

				</div>
				<div class="padding-bottom-40" v-if="!jy_list.length">
					<nomore></nomore>
				</div>

				<div  class="text-right" style="padding: 10px 0">
					<el-pagination background :page-size="jygroup.pagesize" :page-sizes="pageSizes"
						:hide-on-single-page="false" layout="prev, pager, next,sizes"
						@size-change="handleSizeChange($event,'jygroup')"
						@current-change="handleCurrentChange($event,'jygroup')" :current-page="jygroup.currentPage"
						:total="jygroup.totalnum">
					</el-pagination>
				</div>
			</template>
			<template v-if="vctbIndex==1">

				<div v-if="detail">
					<div class="box5 box2_cc">
						<div class="box5_text2 text-bold">公示日期</div>
						<div class="box5_text2 text-bold">处罚决定日期 </div>
						<div class="box5_text2 text-bold">决定书文号</div>
						<div class="box5_text2 text-bold">行政处罚内容</div>
						<div class="box5_text2 text-bold">违法行为类型</div>
						<div class="box5_text2 text-bold">决定机关</div>
					</div>
					<!-- detail.majorpeople -->
					<div v-for="(item, index) in xz_list" :key="index" class="box5">
						<div class="box5_text2">
							{{ item.publicDate?dayjs(Number(item.publicDate)*1000).format('YYYY-MM-DD')  :"--" }}
						</div>
						<div class="box5_text2">{{ item.punishmentDate||"--" }} </div>
						<div class="box5_text2">{{ item.punishmentNo||"--" }} </div>
						<div class="box5_text2 ">{{ item.punishmentInfo||"--" }}</div>
						<div class="box5_text2  ">{{ item.punishmentType||"--" }}</div>
						<div class="box5_text2  ">{{ item.punishmentOrgan||"--" }}</div>
					</div>
					<div v-if="!xz_list.length">
						<nomore></nomore>
					</div>

					<div  class="text-right" style="padding: 10px 0">
						<el-pagination background :page-size="xzgroup.pagesize" :page-sizes="pageSizes"
							:hide-on-single-page="false" layout="prev, pager, next,sizes"
							@size-change="handleSizeChange($event,'xzgroup')"
							@current-change="handleCurrentChange($event,'xzgroup')" :current-page="xzgroup.currentPage"
							:total="xzgroup.totalnum">
						</el-pagination>
					</div>
				</div>
			</template>

		</div>



		<!-- <el-dialog title="资质证书详情" :visible.sync="zsShow">
			<table class="pure-table pure-table-bordered">
				<tbody>
					<tr>
						<td style="width:40%;background: #F7F7F7;">证书类别</td>
						<td>{{zsData.type||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书名称</td>
						<td>{{zsData.name||"--" }}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书编号</td>
						<td>{{zsData.number || '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证日期</td>
						<td>{{zsData.date|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书状态</td>
						<td>{{zsData.status|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">发证机构</td>
						<td>{{zsData.agency|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">业务范围</td>
						<td>{{zsData.formatScope ||'--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书上报日期</td>
						<td>{{zsData.shangbaoDate|| '--'}}</td>
					</tr>
					<tr>
						<td style=" background: #F7F7F7;">证书体系覆盖人数</td>
						<td>{{zsData.payedDate|| '--'}}</td>
					</tr>
				</tbody>
			</table>
		</el-dialog> -->




	</div>

</template>

<script>
	import dayjs from "dayjs"
	export default {
		name: "abnormal-page",
		props: {
			id: {
				type: [String, Number],
				default: ""
			},
			detail: {
				type: Object,
				default: ""
			}
		},
		data() {
			return {
				jy_list: [],
				jygroup: {
					currentPage: 1,
					pagesize: 5,
					pagesize: 10,
					totalnum: 0
				},
				zx_list: [],
				xzgroup: {
					currentPage: 1,
					pagesize: 10,
					type: 0,
					totalnum: 0
				},
				checkShow: false,

				pageSizes: [10, 20, 30, 40, 50],
				vctbIndex: 0
			}
		},
		methods: {
			dayjs,
			showZs(e) {
				this.zsData = e
				this.zsShow = true;
			},
			showRy(e) {
				this.ryData = e
				this.ryShow = true;
			},

			getjyabnormalList() {
				var api = this.$api.api.interfacenew.jyabnormal_list;
				this.$https.post({
						api: api,
						type: "formData",
					}, {
						start: this.jygroup.currentPage,
						page_size: this.jygroup.pagesize,
						id: this.id
					},
					(response) => {
						this.jy_list = response.data;
						this.jygroup.totalnum = response.count;
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getjypunishList() {
				this.$https.post({
						api: this.$api.api.interfacenew.jypunish_list,
						type: "formData",
					}, {
						start: this.xzgroup.currentPage,
						page_size: this.xzgroup.pagesize,
						id: this.id
					},
					(response) => {
						this.xz_list = response.data;
						this.xzgroup.totalnum = response.count;
						this.$forceUpdate()
						console.log("this.xz_list:", this.xz_list)
					},
					(error) => {
						// console.log(error);
					}
				);
			},
			getNumber() {
				let num = 0
				if (this.xzgroup.totalnum) num += this.xzgroup.totalnum;
				if (this.jygroup.totalnum) num += this.jygroup.totalnum;
				this.$emit("rNum", num)
			},
			handleCurrentChange(currentPage, key) {
				this[key].currentPage = currentPage;
				console.log("this[key].currentPage :", this[key].currentPage)
				if (key == "xzgroup") {
					this.getjypunishList();
				} else {
					this.getjyabnormalList();
				}
			},
			handleSizeChange(size, key) {
				this[key].pagesize = size;
				this[key].currentPage = currentPage;
				if (key == "xzgroup") {
					this.getjypunishList();
				} else {
					this.getjyabnormalList();
				}
			},toout(href) {
				// console.log(href)
				if (!href) {
					return false;
				}
				window.open(href)
			},
		},
		created() {
			this.getjyabnormalList();
			this.getjypunishList();
		}
	}
</script>

<style lang="scss" scoped>
	@import '../detailcss.scss';
</style>



// WEBPACK FOOTER //
// abnormal-page.vue?0d2cd908